import { createSelector } from 'reselect'

const getBinders = state => state.binders
const binder_get_binders_selector = createSelector(
	[ getBinders ],
	binders => ({
		page: binders.list.page,
		order_field: binders.list.order_field,
		order_type: binders.list.order_type,
	})
)

export default binder_get_binders_selector
